import { normalizeCityName } from './locationUtils';

interface GeoLocation {
    country: string;
    state?: string;
    city?: string;
    ip?: string;
}

let cachedLocation: GeoLocation | null = null;

export const detectLocation = async (): Promise<GeoLocation | null> => {
    if (cachedLocation) return cachedLocation;
    
    try {
        // 5-second timeout so this never blocks the ad fetch on slow/restricted networks
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 5000);
        const response = await fetch('https://get.geojs.io/v1/ip/geo.json', {
            signal: controller.signal
        });
        clearTimeout(timer);
        const data = await response.json();

        cachedLocation = {
            country: data.country,
            state: data.region,
            city: normalizeCityName(data.city) || data.city || undefined,
            ip: data.ip
        };
        return cachedLocation;
    } catch (error) {
        // Geo lookup failed or timed out — ads still load without location targeting
        return null;
    }
};
